import React, { useContext, useState } from "react";

import { generateClassString as gcs } from "../../../lib/helper/generateClassString";
import { useScrollHandler } from "../../../lib/hooks/useScrollHandler";
import { useIsDesktop } from "../../../lib/hooks/mediaQueries";

import { Button } from "../../Button";
import t from "../../../lib/translate";

import * as styles from "./lang.module.less";
import { LangAside } from "./LangAside/LangAside";
import { Headline } from "../../Headline";

import LogoInfratec from "../../../../static/assets/logo-infratec.svg";
import GeneralPageContext from "../../../templates/GeneralPageContext";
import DivisionInformation from "./DivisionInformation/DivisionInformation";

function LangNav({ active = "" }) {
    const [show, setShow] = useState(false);
    const scrollPositionReached = useScrollHandler(100);
    const isMobile = useIsDesktop();
    const { department, localeVariants } = useContext(GeneralPageContext);

    const phoneContacts = department.division.filter(({ phone }) => !!phone);

    if (localeVariants.length === 0) {
        return (
            <div
                className={gcs(styles.buttonWrapper, [show, styles.activeMenu])}
            >
                <Button
                    type="secondary"
                    icon="language"
                    aria-label={t`navigation.iconNavigation.language`}
                >
                    {t("navigation.iconNavigation.language")}
                </Button>
            </div>
        );
    }

    return (
        <>
            <div
                className={gcs(styles.buttonWrapper, [show, styles.activeMenu])}
            >
                <Button
                    type="secondary"
                    icon="language"
                    onClick={() => setShow(!show)}
                    aria-label={t`navigation.iconNavigation.language`}
                >
                    {t("navigation.iconNavigation.language")}
                </Button>
            </div>

            {show && (
                <div className={styles.widgetWrapper}>
                    <div
                        className={gcs(styles.langWrapper, [
                            scrollPositionReached && !isMobile,
                            styles.onScroll
                        ])}
                    >
                        <div className={styles.langContent}>
                            {isMobile && (
                                <div className={styles.langHeader}>
                                    <div className={styles.langHeaderContent}>
                                        <img
                                            className={styles.logoInfratec}
                                            src={LogoInfratec}
                                            alt={"Infratec"}
                                        />
                                        <Button
                                            type={"secondary"}
                                            icon={"close"}
                                            onClick={() => setShow(!show)}
                                            iconPosition={"left"}
                                        />
                                    </div>
                                </div>
                            )}

                            <LangAside />

                            <div className={styles.regionData}>
                                <div className={styles.addreses}>
                                    <Headline
                                        semanticOfHeadline={"H5"}
                                        hasLightBackground={true}
                                    >
                                        {department.subtitle}
                                    </Headline>

                                    <p>
                                        {`${department.street} ${department.number}`}
                                        <br />
                                        {`${department.zip} ${department.place}`}
                                    </p>

                                    <div className={styles.locationData}>
                                        {department.nestedDepartmentByDivision.mailContact.map(
                                            ({ id, name, email }) => (
                                                <p
                                                    key={`location-${id}`}
                                                    className={styles.location}
                                                >
                                                    <span>{name}</span>
                                                    <span>{email}</span>
                                                </p>
                                            )
                                        )}
                                    </div>
                                </div>

                                <div className={styles.phoneNumbers}>
                                    {phoneContacts.map((division) => (
                                        <DivisionInformation
                                            key={`divInfo-${division.id}`}
                                            name={division.name}
                                            phone={division.phone}
                                            contactUrl={
                                                division?.division?.pageArea
                                                    ?.contactButton?.url
                                            }
                                        />
                                    ))}
                                </div>
                            </div>
                            {!isMobile && (
                                <Button
                                    className={styles.closeButton}
                                    type={"secondary"}
                                    icon={"close"}
                                    onClick={() => setShow(!show)}
                                    iconPosition={"left"}
                                />
                            )}
                        </div>
                    </div>
                    <button
                        className={styles.background}
                        onClick={() => setShow(!show)}
                    />
                </div>
            )}
        </>
    );
}

export { LangNav };
